export default __webpack_public_path__ + "static/media/toggle-bg@2x.65606d87.png";